import { gql } from '@apollo/client/core';

/** Forward ZIP → `GeocodeResult` (nested `location` + mailing fields). Shared by job post and onboarding. */
export default gql`
  query GeocodeZipQuery($input: GeocodeInput!) {
    geocoding {
      geocode(input: $input) {
        location {
          x
          y
        }
        zipCode
        city
        state
        address
      }
    }
  }
`;
